module.exports = new __parcel__URL__("epa-natural-gas--cover.dfae4da5.jpg").toString();